import React, { Fragment, useEffect, useState, useCallback } from 'react';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import AddIcon from '@material-ui/icons/Add';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { COLORS } from '../../styles/colors';
import MenuItem from '@material-ui/core/MenuItem';
import ButtonContent from '../ButtonContent';
import { faPlus, faVideo, faTrash } from '@fortawesome/free-solid-svg-icons'
import YouTubeVideoPreview from './../YouVideoPreview'
import BodyMatrixListing from './../assignments/BodyMatrixListing';
import { ConfirmJsMessage } from '../../helpers.js';
import StartCalendar from "./StartCalendar";
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { AlertJsMessage } from './../../helpers.js';

import moment from 'moment';



const BodyMatrix = props => {

	const {
		clientEmail,
        saveBodyMatrix,
        user,
        fetchBodyMatrixMetas,
        fetchBodyMatrixRanges,
        fetchBodyMatrix,
        deleteBodyMatrixRange,
        isEdit,
        isMobile,
        range
	} = props;

	const [date, setDate] = useState();

    const [passDate, setPassDate] = useState(null);
    const [isOpenVideo, setOpenVideo] = useState(false);
    const [isOpenViewAction, setViewHistory] = useState(false);
    const [videoUrl, setVideoUrl] = useState(null);

    const units = [{
        _id: 'Reps',
        value: 'Reps'
    }, {
        _id: 'Minutes',
        value: 'Minutes'
    }, {
        _id: 'Pounds',
        value: 'Pounds'
    },  {
        _id: 'Centimeters',
        value: 'Centimeters'
    }]

    useEffect(() => {
        if (isEdit && range) {
            fetchBodyMatrixList([range._id])
        } else {
            fetchMetaData([])
        }
     }, [clientEmail])

    const [categories, setCategories] = useState([]);
    const [exercises, setExercises] = useState([]);

    const fetchBodyMatrixList = (rangeIds) => {
        fetchBodyMatrix(rangeIds)
        .then((res) => {
           const data = res.data;
           const rangeList = data.data;
           fetchMetaData(rangeList);
        })
    }

    const fetchMetaData = (rangeList) => {
        fetchBodyMatrixMetas().
        then((res) => {
            const data = Object.values(res);
            const categories = data.filter((c) => {
                return !c.categoryId && !c.isOtherExercise
            });
            const otherExercise = data.find((c) => {
                return c.isOtherExercise
            });
            let exercises = data.filter((c) => {
                return c.categoryId && !c.isOtherExercise
            });
            for(let i = 0; i < categories.length; i++) {
                exercises.push({
                    ...otherExercise,
                    categoryId: categories[i]['_id']
                })
            }
            setCategories([...categories]);
            setExercises([...exercises]);
            if (rangeList && rangeList.length > 0) {
                const updateRangeList = rangeList.map((item) => {
                    return {
                        ...item,
                        categories,
                        units,
                        clientId: makeid(10),
                        exercises: exercises.filter((c) => {
                            return c.categoryId === item.categoryId;
                        })
                    }
                })
                setOldList(updateRangeList)
                setList(updateRangeList);
            } else {
                addNewList(categories, exercises)
            }
        })
    }



    const addNewList = (categories, exercises) => {
        setList([
            ...list,
            {
                categoryId: '',
                exerciseId: '',
                current: '',
                goal: '',
                isOtherExercise: false,
                url: '',
                units: units,
                unit: 'Reps',
                categories: categories,
                exercises: filterExercises(categories[0]['_id']),
                clientId: makeid(10),
                isDelete: false
            }
        ])
    }


    const filterExercises = (value) => {
        return exercises.filter((c) => {
            return c.catId === value;
        })
    }


    const makeid = (length) => {
        var result = '';
        var characters = '0123456789';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

    const [list, setList] = useState([]);
    const [oldList, setOldList] = useState([]);
    const [prePareData, setPrePareData] = useState([]);

    const changeStartDate = (data) => {
        const date = new Date(data);
        setPassDate(date);
    }

    const onChange = (evt, clientId) => {
        let { value, name } = evt.target
        if (name === 'current' || name === 'goal') {
            const re = /^[0-9\b]+$/;
            if (value !== '' &&  !re.test(value)) {
                return;
            }
        }
        const updateList = [...list];
        const findIndex = list.findIndex((l) => {
            return l.clientId === clientId
        })
        updateList[findIndex] = {
            ...updateList[findIndex],
            [name]: value
        }
        setList([...updateList])
    }

    const submitData = async() => {
        if(date === '') {
            AlertJsMessage('Date is required.');
            return;
        }
        let cloneList = [...list];
        let reqItems = [];
        let index = 0;
        for (const l of cloneList) {
            let item = l;
            item.orderId = index + 1;
            reqItems.push(item);
            index = index + 1;
        }
        let isDateChange = true;
        let isBodyMatrixChange = true;
        if(range) {
            const rangeDateWithoutZone = moment(range.startDate).utc(0, true).format('YYYY-MM-DD');
            const a = moment(passDate);
            const b = moment(rangeDateWithoutZone);
            const diff = a.diff(b, 'days');
            isDateChange = diff > 0;
            isBodyMatrixChange = true;
        }

        saveBodyMatrix({
            startDate: passDate,
            clientEmail: clientEmail,
            bodyMatrix: reqItems,
            isDateChange: isDateChange,
            isBodyMatrixChange: isBodyMatrixChange,
            _id: range ? range._id : undefined
        })
        .then((res) => {
            if (range) {
                setList([])
                fetchBodyMatrixList([range._id])
                if (res.bodyMatrixRangeDetails) {
                    props.parentData(res.bodyMatrixRangeDetails)
                }
            }
        })
    }

    const addBodyMatrix = () => {
        addNewList(categories, exercises)
    }

    const selectUnits = (event, clientId) => {
        const { value } = event.target;
        const updateList = [...list];
        const findIndex = list.findIndex((l) => {
            return l.clientId === clientId
        })
        updateList[findIndex] = {
            ...updateList[findIndex],
            unit: value
        }
        console.log(updateList);
        setList([...updateList])
    }

    const selectCategory = (event, clientId) => {
        const { value } = event.target;
        const filterExercises = exercises.filter((c) => {
            return c.categoryId === value;
        })
        const updateList = [...list];
        const findIndex = list.findIndex((l) => {
            return l.clientId === clientId
        })
        updateList[findIndex] = {
            ...updateList[findIndex],
            categoryId: value,
            exercises: filterExercises
        }
        setList([...updateList])
    }

    const YouTubeGetID = (url) => {
        url = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
        return (url[2] !== undefined) ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];
     }

    const openVideo = (id) => {
        const filterExercises = exercises.filter((c) => {
            return c._id === id;
        })
        if (filterExercises.length > 0) {
            setVideoUrl(YouTubeGetID(filterExercises[0]['url']));
            setOpenVideo(true);
        }
    }

    const selectExercise = (event, clientId) => {
        const { value } = event.target;
        const updateList = [...list];
        const findIndex = list.findIndex((l) => {
            return l.clientId === clientId
        })
        let isOtherExercise = false;
        const exercise = list[findIndex].exercises.find((e) => e._id === value);
        isOtherExercise = exercise.isOtherExercise ? true : false;
        updateList[findIndex] = {
            ...updateList[findIndex],
            exerciseId: value,
            isOtherExercise
        }
        setList([...updateList])
    }

    const deleteBodyMatrix =  (index) => {
        const updateList = list.filter((l) => !l.isDelete);
        if (updateList.length > 1) {
            updateList[index]['isDelete'] = true;
            setList([
                ...updateList
            ])
        }
    }

    const viewHistory = () => {
        setViewHistory(!isOpenViewAction)
    }

    const isDisbaledSave = () => {
        const updateList = list;
        const filterList = updateList.filter((l) => !l.isDelete)
        const checkList = filterList.filter((l) => {
            let condition;
            if (!l.isOtherExercise) {
               condition = (l.categoryId === '' ||
               l.exerciseId === '' || l.goal === '');
            } else {
                condition = (l.categoryId === '' ||
               l.exerciseId === '' || l.goal === ''
               || l.otherExerciseName === '');
            }
            return condition;
        })
        return checkList.length > 0
    }



    const filterList = list.filter((l) => !l.isDelete)

    let startDate;
    if (range) {
        startDate = moment(range.startDate).utc(0, true);
        const month = startDate.format('M');
        const day   = startDate.format('D');
        const year  = startDate.format('YYYY');
        startDate = new Date(`${year}-${month}-${day}`)
    }

    return (
        <Fragment>
                { !isEdit &&
                    (<div style={{
                                    marginTop: '5px',
                                    textAlign: 'right'
                                }}>
                            <Button
                                color="primary"
                                onClick={() => viewHistory()}
                                style={{
                                    color: COLORS.orange,
                                    fontSize: '10px'
                                }}
                            >
                                <ButtonContent text={ !isOpenViewAction ? "View History" : "Back" }  />
                            </Button>
                        </div> )
                    }
                    { isOpenViewAction && (
                        <BodyMatrixListing
                            fetchBodyMatrixRanges = { fetchBodyMatrixRanges}
                            clientEmail = {clientEmail}
                            fetchBodyMatrix = { fetchBodyMatrix }
                            saveBodyMatrix = { saveBodyMatrix }
                            deleteBodyMatrixRange = { deleteBodyMatrixRange }
                            fetchBodyMatrixMetas = { fetchBodyMatrixMetas}
                            user = {user}
                            isMobile = { isMobile }
                        >
                        </BodyMatrixListing>)
                    }
                    { !isOpenViewAction && (
                    <div
                        style={{
                            marginTop: !isEdit ? 25 : 0,
                            width: isMobile ? '100%' : '600px'
                        }}
                    >


                    <div style={{marginTop: '5px'}}>
                    <div style={{
                                    display: 'flow-root',
                                    padding: 20,
                                    paddingLeft: 0,
                                    width: '100%',
                                    height: '90px'
                                    }}>
                                <div style={{
                                    display: 'initial',
                                    float: 'left',
                                    width: isMobile ? '100%' : '400px'
                                }}>
                                <p><strong>Select Month</strong></p>
                                    <StartCalendar bottomLeftPosition="true" startDate={startDate} formDataPicker={'MM/YYYY'} isOnlyMonthPicker={true} changeStartDate={changeStartDate}  />
                                </div>
                                <div style={{
                                    display: 'initial',
                                    float: 'left',
                                    width: isMobile ? '100%' : '400px',
                                    marginTop: '5px'
                                }}>
                                <p><strong>Enter Functional Strength Information.</strong></p>
                                </div>
                            </div>
                            <div style={{marginTop: '40px'}}>
                            <YouTubeVideoPreview channel='youtube' isOpen={isOpenVideo} isMobile={isMobile} videoId={videoUrl} onClose={() => setOpenVideo(false)} />
                            {filterList.map((l, index) =>  {
                                        return (
                                            <Fragment>
                                                <div  style={{
                                                    marginLeft: '2px',
                                                    display: isMobile && 'flex'
                                                }}>
                                                    <Grid container spacing={12} style={{'marginTop': isMobile ? '25px' : '15px'}}>
                                                        <Grid item xs={isMobile ? 12 : 2} >
                                                            <TextField
                                                                label="Category"
                                                                value={l.categoryId}
                                                                name="Category"
                                                                margin="dense"
                                                                variant="outlined"
                                                                select
                                                                onChange={event => selectCategory(event, l.clientId)}
                                                            >
                                                            {l.categories && l.categories.map(option => (
                                                                <MenuItem key={option._id} value={option._id}>
                                                                    {option.name}
                                                                </MenuItem>
                                                            ))}
                                                            </TextField>
                                                        </Grid>
                                                        <Grid item xs={isMobile ? 12 : 2} style={{
                                                                marginLeft: isMobile ? '0px' : '5px',
                                                            }}>
                                                            <TextField
                                                                label="Exercise"
                                                                name="Exercise"
                                                                margin="dense"
                                                                variant="outlined"
                                                                select
                                                                value={l.exerciseId}
                                                                onChange={event => selectExercise(event,  l.clientId)}
                                                            >
                                                            {l.exercises.map(option => (
                                                                <MenuItem key={option._id} value={option._id}>
                                                                    {option.name}
                                                                </MenuItem>
                                                            ))}
                                                            </TextField>
                                                        </Grid>
                                                        <Grid item xs={isMobile ? 12 : 2} style={{
                                                                marginLeft: isMobile ? '0px' : '5px',
                                                            }}>
                                                            <TextField
                                                                label="Current"
                                                                value={l.current}
                                                                name="current"
                                                                margin="dense"
                                                                variant="outlined"
                                                                onChange={event => onChange(event, l.clientId)}
                                                                inputProps={{
                                                                    maxLength: 60,
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={isMobile ? 12 : 2} style={{
                                                                marginLeft: isMobile ? '0px' : '5px',
                                                            }}>
                                                            <TextField
                                                                label="Goal"
                                                                value={l.goal}
                                                                name="goal"
                                                                margin="dense"
                                                                variant="outlined"
                                                                onChange={event => onChange(event, l.clientId)}
                                                                inputProps={{
                                                                    maxLength: 60,
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={isMobile ? 12 : 2} style={{
                                                                marginLeft: isMobile ? '0px' : '5px',
                                                            }}>
                                                            <TextField
                                                                label="Unit"
                                                                value={l.unit}
                                                                name="unit"
                                                                margin="dense"
                                                                variant="outlined"
                                                                select
                                                                onChange={event => selectUnits(event, l.clientId)}
                                                            >
                                                            {l.units && l.units.map(option => (
                                                                <MenuItem key={option._id} value={option.value}>
                                                                    {option.value}
                                                                </MenuItem>
                                                            ))}
                                                            </TextField>
                                                        </Grid>

                                                <span
                                                    className="link"
                                                    style={{ float: 'right', marginTop: '10px', marginLeft: isMobile ? '0px' : '5px' }}
                                                >
                                                { l.exerciseId !== '' && !l.isOtherExercise &&
                                                <FontAwesomeIcon onClick={() => openVideo(l.exerciseId)} size={isMobile && "2x" } icon={faVideo} title={'Video'}
                                                        style={{ marginRight: 5, color: COLORS.orange }} />
                                                }

                                                </span>
                                                <span
                                                    className="link"
                                                    style={{ float: 'right', marginTop: '10px', marginLeft: isMobile ? '20px' : '5px' }}
                                                >
                                                <FontAwesomeIcon onClick={() => deleteBodyMatrix(index)} size={isMobile && "2x" } icon={faTrash} title={'Delete'}
                                                        style={{ marginRight: 5, color: COLORS.orange }} />
                                                </span>
                                                { index === (filterList.length - 1)  &&
                                                    <span
                                                        className="link"
                                                        style={{ float: 'right', marginTop: '10px', marginLeft: isMobile ? '20px' : '5px', }}
                                                    >
                                                        <FontAwesomeIcon icon={faPlus} size={isMobile && "2x" } onClick={() => addBodyMatrix()} title={'Add'}
                                                            style={{ marginRight: 5, color: COLORS.orange }} />
                                                    </span>
                                                }
                                                { l.isOtherExercise &&
                                                    <Fragment>
                                                        <FormControl component="fieldset" style={{'marginTop': isMobile && '10px'}}>
                                                            <FormLabel component="legend">Enter Exercise Information.</FormLabel>
                                                            </FormControl>
                                                        <Grid item xs={isMobile ? 12 : 3 } style={{
                                                                        marginLeft: isMobile ? '0px' : '5px'
                                                                    }}>
                                                                    <TextField
                                                                        label="Exercise Name"
                                                                        value={l.otherExerciseName}
                                                                        name="otherExerciseName"
                                                                        margin="dense"
                                                                        variant="outlined"
                                                                        onChange={event => onChange(event, l.clientId)}
                                                                        inputProps={{
                                                                            maxLength: 100,
                                                                        }}
                                                                    />
                                                                </Grid>
                                                        </Fragment>
                                                    }
                                                </Grid>
                                            </div>
                                            </Fragment>)
                                    })}
                            </div>
                            <div style={{ marginTop: '10px'}}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => submitData()}
                                    disabled={isDisbaledSave()}
                                >
                                    <ButtonContent
                                        text="Save"
                                        icon="chevron-right" />
                                </Button>
                            </div>
                        </div>
                    </div>
                    )}
        </Fragment>
    );
};

export default BodyMatrix;



// WEBPACK FOOTER //
// ./src/components/assignments/BodyMatrix.js